import * as Yup from 'yup';
import { DomainObject } from '@eas/common-web';

export function useValidationSchema<T extends DomainObject>() {
  return Yup.object<T>();
}
